import React from "react";

export default function Title( {winner} ) {
    return (
        <div className="title">
            {titleText(winner)}
        </div>
    )
}

function titleText(isWinner) {
    if (isWinner) {
        return <p><b>Congratulations!</b> You have bingo!!</p>
    }
    return <p>Tiffany's Baby Bingo Board!</p>
} 
